import moment from 'moment'

export const cleanData2Table = (prevData, currentData, noData) =>{
    let temp = {
        id: currentData.id_ctrl_stamping,
        completed: currentData.completed ? true : false,
        files:[],
        data:[]
    }

    let fixedDataA = [
        currentData.businesses_name ? currentData.businesses_name : noData,
        currentData.rfc ? currentData.rfc : noData,
        currentData.client_status ? currentData.client_status : noData,
        currentData.client_classification ? currentData.client_classification : noData,
        currentData.fiscal_regime ? currentData.fiscal_regime : noData,
        currentData.peridiocity ? currentData.peridiocity : noData,
        currentData.workers_limit ? currentData.workers_limit : noData,
        currentData.roster_type ? currentData.roster_type : noData
    ];

    let varData = [
        currentData.employee_number ? currentData.employee_number.toString() : noData,
        currentData.payment_date ? moment(currentData.payment_date).format('DD-MM-YYYY') : noData,
        currentData.stamping_date ? moment(currentData.stamping_date).format('DD-MM-YYYY') : noData,
        {key:'document'},
        currentData.responsible ? currentData.responsible : noData,
        currentData.collections_charge ? currentData.collections_charge : noData,
        currentData.notes ? currentData.notes : noData,
        currentData.extra_hours ? currentData.extra_hours : noData,
        {key:'hours_proof'},
        currentData.extra_charges ? currentData.extra_charges : noData,
        {key:'charge_proof'},
        currentData.completition_date ? moment(currentData.completition_date).format('DD-MM-YYYY') : noData,
    ]

    let origin_data = {
        employee_number: currentData.employee_number,
        payment_date: currentData.payment_date,
        stamping_date: currentData.stamping_date,
        responsible_id: currentData.responsible_id,
        notes : currentData.notes,
        extra_hours : currentData.extra_hours,
        extra_charges : currentData.extra_charges,
        collections_charge : currentData.collections_charge,
        completition_date : currentData.completition_date
    }

    let tempA = {...temp}
    tempA.data = [...fixedDataA]
    prevData.fixedDataA.push(tempA);

    let tempVar = {...temp}
    tempVar.data = [...varData]
    tempVar.files = [
        {id:currentData.id_ctrl_stamping,key:'document',name:'Adjuntar Documento',path:'document',
            status: checkStatus(currentData, 'document')},
        {id:currentData.id_ctrl_stamping,key:'hours_proof',name:'Comprobante de horas',path:'hoursproof',
            status: checkStatus(currentData, 'hours_proof')},
        {id:currentData.id_ctrl_stamping,key:'charge_proof',name:'Tabla SAT',path:'chargeproof',
            status: checkStatus(currentData, 'charge_proof')}
    ]
    tempVar.origin_data = {...origin_data}
    
    prevData.varData.push(tempVar);
    return prevData;
}

const checkStatus = (item, key) => {
    return item[key] !== "0" && item[key] !== 0 && item[key] !== ""
}
